import React from 'react';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';
import SectionTitle from '../sectionTitle/SectionTitle';

const features = [
    {
        icon: 'icon-award-fill',
        title: '20 Years of Proven Excellence'
    },
    {
        icon: 'icon-flag-fill',
        title: '9,000+ Successful Alumni'
    },
    {
        icon: 'icon-user-fill',
        title: 'Dedicated & Experienced Faculty'
    },
    {
        icon: 'icon-settings-fill',
        title: 'Holistic Character Development'
    }
];

const AboutThree = () => {
    return (
        <div className="edu-choose-us-area-one choose-us-style-1 edu-section-gap bg-color-white">
            <div className="container">
                <div className="row">
                    <div className="col-xl-5 col-lg-6">
                        <div className="thumbnail">
                            <img src="/images/about/about-03/choose-us-image-01.png" alt="Why Choose Green Cap" />
                        </div>
                    </div>

                    <div className="col-xl-6 col-lg-6 offset-xl-1">
                        <div className="inner mt_md--40 mt_sm--40">
                            <SectionTitle
                                classes="text-start"
                                slogan="Why Choose Us"
                                title="Why Thousands of Families Trust Green Cap"
                            />

                            <ScrollAnimation animateIn="fadeInUp" animateOut="fadeInOut" animateOnce={true}>
                                <p className="line-before mb--5">
                                    We go beyond academic results. At Green Cap High School, education means building character, inspiring ambition, and creating opportunities — nurturing confident, responsible, and forward-thinking individuals prepared to meet the challenges of a dynamic world.
                                </p>
                            </ScrollAnimation>

                            <div className="feature-style-2">
                                {features.map((item, i) => (
                                    <ScrollAnimation
                                        animateIn="fadeInUp"
                                        animateOut="fadeInOut"
                                        animateOnce={true}
                                        className="single-feature"
                                        key={i}
                                    >
                                        <div className="icon">
                                            <i className={item.icon}></i>
                                        </div>
                                        <div className="content">
                                            <h6 className="feature-title">{item.title}</h6>
                                        </div>
                                    </ScrollAnimation>
                                ))}
                            </div>

                            <ScrollAnimation animateIn="fadeInUp" animateOut="fadeInOut" className="read-more-btn mt--60" animateOnce={true}>
                                <Link className="edu-btn" to="/contact-us">Enroll Your Child <i className="icon-arrow-right-line-right"></i></Link>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutThree;
